module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Upload de votre CV","b":"Choisissez votre CV le plus complet","c":"Au format Word ou Pdf","d":"Uploader mon CV","e":"Erreur lors de l\u0027upload.","f":"Analyse de votre CV en cours..."},"en":{"a":"Upload your CV","b":"Choose your most detailed CV","c":"File format : Word or Pdf","d":"Upload my CV","e":"An error occurred during the upload.","f":"Analyzing CV..."}}')
  delete Component.options._Ctor
}
